import * as React from "react";
import { Box, Divider, LinearProgress, Typography } from "@mui/material";
import { translate } from "../../../../../translate/translate";
import { NpiProject } from "../types/npi-project.types";

interface NpiProjectMetricsProps {
    project: NpiProject;
}

const labelSx = {
    fontWeight: 700,
    fontSize: "11px",
    letterSpacing: "8%",
    color: "#777A80",
};

const valueSx = {
    fontWeight: 800,
    fontSize: "28px",
    color: "#1B1F27",
};

const NpiProjectMetricsComponent: React.FC<NpiProjectMetricsProps> = ({ project }) => {
    return (
        <Box>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    pl: "40px",
                    pr: "40px",
                    border: "1px solid transparent",
                    backgroundColor: "#FFFFFF",
                    pt: "13px",
                    pb: "13px",
                }}>
                <Box>
                    <Typography sx={labelSx}>
                        {translate.t("npi_project")}:
                    </Typography>
                    <Typography sx={valueSx}>
                        {project.projectName}
                    </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <Box sx={{ minWidth: 220 }}>
                        <Typography sx={labelSx}>
                            {translate.t("progress").toUpperCase()}
                        </Typography>
                        <Typography sx={valueSx}>
                            {project.progress}%
                        </Typography>
                        <LinearProgress
                            variant="determinate"
                            value={project.progress}
                            sx={{
                                height: 6,
                                borderRadius: 3,
                                mt: 0.5,
                                backgroundColor: "#E5E7EB",
                                "& .MuiLinearProgress-bar": { backgroundColor: "#003FFB !important" },
                            }}
                        />
                    </Box>

                    <Box>
                        <Typography sx={labelSx}>
                            {translate.t("activities").toUpperCase()}
                        </Typography>
                        <Typography sx={valueSx}>
                            {project.completedActivities}/{project.totalActivities}
                        </Typography>
                    </Box>

                    <Box>
                        <Typography sx={labelSx}>
                            FRC
                        </Typography>
                        <Typography sx={valueSx}>
                            {project.frc}
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Divider sx={{ borderColor: "#E2E8F0", borderBottomWidth: "2px", ml: "-15px" }} />
        </Box>
    );
};

export default NpiProjectMetricsComponent;
